import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../../Components/Sidebar/Sidebar";
import "./PrivateLayout.css";
import PublicHeader from "../../Components/PublicHeader/PublicHeader";
import NavigationBinder from "../../Utils/NavigationBinder";

const PrivateLayout = () => {

  const [isCollapsed, setIsCollapsed] = useState(false)

  // Function to toggle sidebar
  const toggleSidebar = () => {
    setIsCollapsed((prev) => !prev);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsCollapsed(true);
      } else {
        setIsCollapsed(false);
      }
    };

    handleResize(); // Check on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <NavigationBinder />
      <div className="layout d-flex">
        <Sidebar isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />
        <div className={`main-contnt d-flex flex-column ${isCollapsed ? "w-100 m-0" : "margin-class"}`}>
          <PublicHeader toggleSidebar={toggleSidebar} />
          <div>
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivateLayout;